module.exports = __webpack_public_path__ + "media/ascorbic-medium.85d29a4e.mp4";